export const BASE_URL = process.env.REACT_APP_API;
export const BASE_OAUTH = process.env.REACT_APP_OAUTH;
export const CLIENT_ID = process.env.REACT_APP_CLIENT;
export const LOCAL_URL = process.env.REACT_APP_LOCAL;
export const USERS_URL = process.env.REACT_APP_USERS;
export const DOCS_URL = process.env.REACT_APP_DOCS;
export const ACCOUNTANT_URL = process.env.REACT_APP_ACCOUNTANT;
export const REASEGURO_URL = process.env.REACT_APP_REASEGURO;
export const ANALYST_URL = process.env.REACT_APP_ANALYST;
export const RISK_URL = process.env.REACT_APP_RISK;
export const POLICY_URL = process.env.REACT_APP_POLICY;
export const SINIESTROS_URL = process.env.REACT_APP_SINIESTROS;
export const SEARCH_DELAY_MS = process.env.REACT_APP_SEARCH_DELAY_MS;

export const ORSAN_LOGO_URL = "https://pub-3ff0bf4b9e934ca3ae258ae98e7eefd1.r2.dev/logo-orsan-seguros-azul-corto.png";

export const API = {
  login: 'authorize',
  endSession: 'end-session',
  userinfo: 'userinfo',
  productos: 'productos',
  tiposCobertura: 'tipos_cobertura',
  monedas: 'monedas',
  tiposEndosoGarantia: 'tipos-endoso-garantia',
  creditos: 'creditos',
  simpleCreditos: 'simple-creditos',
  simpleEndososCredito: 'simple-endosos-credito',
  garantias: 'garantias',
  fullCreditos: 'full-creditos',
  fullGarantia: 'full-garantia',
  garantiasIntermediarios: 'garantias-intermediarios',
  garantiaIntermediario: 'garantia-intermediario',
  creditosIntermediarios: 'creditos-intermediarios',
  fullCreditosIntermediarios: 'full-creditos-intermediarios',
  fullLineaGarantia: 'full-linea-garantia',
  lineasGarantiaIntermediarios: 'lineas-garantia-intermediarios',
  clientes: 'clientes',
  clientesIntermediario: 'clientes-intermediario',
  tiposDeudor: 'tipos-deudor',
  paises: 'paises',
  deudores: 'deudores',
  lineasCredito: 'lineas-credito',
  simpleLineasCredito: 'simple-lineas-credito',
  movimientosLineaCredito: 'movimientos-linea-credito',
  lineasCreditoBulkUpload: 'bulk-upload-credit-lines',
  lineasCreditoBulkUploadTemplate: 'lineas-credito/template_carga_deudor_xlsx',
  librosVenta: 'libros-venta',
  uploadLibroVenta: 'upload_libro_ventas',
  updateLibroVenta: 'update_libro_ventas',
  closeAllLibrosVenta: 'close-all-libros-venta',
  uploadDocumento: 'upload-documento',
  processCarpetaTributaria: 'process-carpeta-tributaria',
  liquidacion: 'liquidacion',
  cuotasCredito: 'cuotas-credito',
  prorrogasPagoDte: 'prorrogas-pago-dte',
  dtesLibroVenta: 'dtes-libro-venta',
  estadosDocumento: 'estados-documento',
  estadosSolicitudProrroga: 'estados-solicitud-prorroga',
  bulkUploadProrrogas: 'bulk-upload-prorrogas',
  prorrogasBulkUploadTemplate: 'prorrogas-pago-dte/template_carga_prorroga_xlsx',
  estadosMovimiento: 'estados-movimiento',
  estadosLinea: 'estados-linea',
  fullPolizas: 'full-polizas',
  ramosFecu: 'ramos-fecu',
  tiposIntermediario: 'tipos-intermediario',
  tempFileDownload: 'download-temp-file',
  downloadDocumento: 'download-documento',
  createResumenLibroVentas: 'create-resumen-libro-ventas-cierre',
  librosVentaBulkUpload: 'bulk-upload-libro-ventas',
  organizations: 'organizations',
  clasificaciones: 'clasificaciones/',
  deudorPorPoliza: 'deudores-por-poliza',
  facturasProrroga: 'facturas-prorrogas',
  facturaPlanpagoRelation: 'factura-planpago-relation',
  planPagoProrroga: 'plan-pago-prorroga',
  estadosProrrogaPlanPago: 'estados-plan-pago-prorroga',
  tipoPlanPagoProrroga: 'tipo-plan-pago-prorroga',
  simpleProrroga: 'simple-prorroga',
  simpleProrrogaComentarios: 'simple-prorroga-comentarios',
  documentoTributario: 'documento-tributario',
  accionesPermitidas: 'acciones-permitidas',
  accionesTipos: 'acciones-tipos',
  siniestros:'siniestros'

};

export const PROFILES = {
  ceo: 'ceo',
  administradorTI: 'administrador-ti',
  consultaBasico: 'consulta-basico',
  comercialGarantia: 'comercial-garantia',
  suscripcionGarantia: 'suscripcion-garantia',
  gerenteRiesgoGarantia: 'gerente-riesgo-garantia',
  analistaRiesgoGarantia: 'analista-riesgo-garantia',
  comercialCredito: 'comercial-credito',
  riesgoCredito: 'riesgo-credito',
  fiscalia: 'fiscalia',
  actuariado: 'actuariado',
  gerenteOperaciones: 'gerente-operaciones',
  analistaOperaciones: 'analista-operaciones',
  riesgoOperacional: 'riesgo-operacional',
  siniestros: 'siniestros',
  recuperoSiniestros: 'recupero-siniestros',
  administrador: 'administrador',
  consultaEspecial: 'consulta-especial',
  gerenteGarantia: 'gerente-garantia',
  gerenteRiesgoCredito: 'gerente-riesgo-credito',
  administrativoRiesgoCredito: 'administrativo-riesgo-credito',
  analistaRiesgoCredito: 'analista-riesgo-credito',
  externoAdministradorCorredorCredito: 'externo-administrador-corredor-credito',
  visualizacionProrrogasCredito: 'visualizacion-prorrogas-credito',
  externoAdministradorAseguradoCredito: 'externo-administrador-asegurado-credito',
  externoAseguradoCreditoSoloVista: 'externo-asegurado-credito-solo-vista', // perfil ficticio
};

export const ADMIN_ROLES = [PROFILES.ceo, PROFILES.administradorTI];


export const ESTADOS_MOVIMIENTOS = {
  rechazado: 'rechazado',
  procesando: 'procesando',
  error: 'error',
  pendiente: 'pendiente',
}

export const ESTADOS_LINEAS = {
  rechazada: 'rechazada',
  pendiente: 'pendiente',
  bloqueado: 'bloqueado',
  error: 'error',
  aprobada: 'aprobada',
  limitada: 'limitada',
  reducida: 'reducida',
}

export const TIPO_MOVIMIENTO_LINEA_CREDITO = {
  migracion: 'migracion',
}

export const DEFAULT_PAGE_SIZE = 10;
export const calculatePages = (rows) => Math.ceil(rows / DEFAULT_PAGE_SIZE);

// Date formats
export const BACKEND_DF = 'YYYY-MM-DD';
export const FRONT_DF_1 = 'DD-MM-YYYY';
export const FRONT_DF_2 = 'DD-MMM-YYYY';
export const FRONT_MF = 'MMMM-YYYY';

export const TIPO_PLAN_CUOTAS_ID = 2;
export const TIPO_PLAN_LIBRO_VENTAS_ID = 3;
export const TIPO_PLAN_PLAN_PAGOS_ID = 4;

export const TIPO_ENDOSO_EMISION_ID = 1;
export const TIPO_ENDOSO_RENOVACION_ID = 2;
export const TIPO_ENDOSO_MODIFICACION_ID = 3;

export const ROLES_ASEGURADO_CREDITO = ['aseguradocredito']; //'filialcredito'];
export const ROLES_CORREDOR_CREDITO = ['intermediariocredito'];
export const ROLES_ASEGURADO_GARANTIA = ['afianzadogarantia'];
export const ROLES_CORREDOR_GARANTIA = ['intermediariogarantia'];
export const ROLES_CORREDOR_COMISIONES = ['intermediariocomisiones'];
export const ROLES_PRORROGA = ['visualizacionprorrogas'];

export const ROLES_ASEGURADO = [...ROLES_ASEGURADO_CREDITO, ...ROLES_ASEGURADO_GARANTIA];
export const ROLES_CORREDOR = [...ROLES_CORREDOR_CREDITO, ...ROLES_CORREDOR_GARANTIA];

export const NO_FILTERED_ID = -1;
export const ALL_OPTIONS = 'all-options';

// User roles
export const ROL_DEUDOR_CREDITO = 'deudorcredito';

// Libro ventas
export const LIBRO_VENTAS_DIA_LIMITE_CARGA = 20;

export const STORAGE_CLIENT_KEY = 'cliente';
export const STORAGE_CORREDOR_KEY = 'corredor';

// Cuotas crédito
export const ESTADO_CUOTA_CREDITO_PAGADO = 'pagado';
export const ESTADO_CUOTA_CREDITO_PENDIENTE = 'pendiente';
export const FORMA_PAGO_LIBRO_VENTAS = 'libroventas';
export const TIPO_PAGO_PRIMA = 'prima';

// Prorroga DTE
export const ESTADO_SOLICITUD_PRORROGA_PENDIENTE_ID = 3;

// Estados poliza
export const CONSTRUCTION_LABEL = 'Construcción';
export const DRAFT_LABEL = 'Borrador';
export const EMITTED_LABEL = 'Emitida';
export const CANCELED_LABEL = 'Cancelada';

export const GEO_PAIS_CHILE_ID = 4;

export const RAMO_FECU_CREDITO_DOMESTICO_NEMOTECNICO = '27';
export const RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO = '28';

// Estado Deudor
export const ESTADOS_DEUDOR = {
  bloqueado: 'bloqueado'
}

// API constants
export const TIPO_INDEMNIZACION_MAXIMA_VECES_PRIMA_INICIAL_ID = 1;
export const TIPO_GESTIONES_PROPIAS_EMISION_ID = 1;
